import { SearchFilterV4 } from "@/types/SearchFilter";
import { Button } from "@components/ui/button";
import { ButtonGroup } from "@components/ui/button-group";
import { MegaphoneIcon, XIcon } from "lucide-react";
import { Trans } from "@lingui/react/macro";
import { useI18n } from "@/contexts/i18nContext";
import { Dispatch, SetStateAction } from "react";

export default function Reach({
  setIsReachOpen,
  onChange,
  value,
}: {
  onChange: (value: SearchFilterV4, clear?: boolean) => void;
  setIsReachOpen: Dispatch<SetStateAction<boolean>>;
  value: SearchFilterV4["min_reach_threshold"];
}) {
  const { abbreviateNumber } = useI18n();

  return (
    <ButtonGroup>
      <Button
        render={<div />}
        nativeButton={false}
        disabled
        size="xs"
        variant="outline"
        className="pointer-events-none"
      >
        <MegaphoneIcon />
        <Trans>Räckvidd</Trans>
      </Button>
      <Button
        render={<div />}
        nativeButton={false}
        disabled
        size="xs"
        variant="outline-muted"
        className="pointer-events-none"
      >
        <Trans>från</Trans>
      </Button>
      <Button
        size="xs"
        variant="outline"
        type="button"
        onClick={() => {
          setIsReachOpen(true);
        }}
      >
        {value !== undefined ? abbreviateNumber(value) : "N/A"}
      </Button>
      <Button
        size="icon-xs"
        variant="outline"
        type="button"
        onClick={() => {
          onChange({
            min_reach_threshold: undefined,
          });
        }}
      >
        <XIcon />
        <span className="sr-only">
          <Trans>Ta bort filter</Trans>
        </span>
      </Button>
    </ButtonGroup>
  );
}
